import { render, staticRenderFns } from "./gift-card-options.vue?vue&type=template&id=c3b800c8&scoped=true"
import script from "./gift-card-options.vue?vue&type=script&lang=js"
export * from "./gift-card-options.vue?vue&type=script&lang=js"
import style0 from "./gift-card-options.vue?vue&type=style&index=0&id=c3b800c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b800c8",
  null
  
)

export default component.exports